import React from "react";

export default function TrainingReportItem(props) {
  const { data } = props;

  return (
    <React.Fragment>
      <a
        href="#"
        className={"dx-link dx-icon-doc dx-link-icon"}
        title="Report"
        aria-label="Report"
        style={{
          backgroundColor: data.rpt ? "transparent" : "rgba(244, 67, 54, 0.32)",
          visibility: data.provider != 2 ? "hidden" : "visible",
        }}
      />
    </React.Fragment>
  );
}
